import firebase from "firebase";

const getTCAndPPFromRemoteConfig = () => {
  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  return remoteConfig
    .fetchAndActivate()
    .then(() => {
      return {
        pp: remoteConfig.getValue("current_PP_version"),
        tc: remoteConfig.getValue("current_TC_version"),
      };

    })
    .catch((err) => {
      throw err
    });
};

const getUrlsLocationFromRemoteConfig = () => {
  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  return remoteConfig
    .fetchAndActivate()
    .then(() => {
      return remoteConfig.getValue("URLS_LOCATION");
    })
    .catch((err) => {
      throw err
    });
};

const getPromotionPopupConfig = () => {
  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  return remoteConfig
    .fetchAndActivate()
    .then(() => {
      return remoteConfig.getValue("PROMOTION_POPUP");
    })
    .catch((err) => {
      throw err;
    });
};

const getSeasonRegistrationUrl = () => {
  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  return remoteConfig
    .fetchAndActivate()
    .then(() => {
      return remoteConfig.getValue("SEASON_REGISTRATION");
    })
    .catch((err) => {
      throw err;
    });
};

const getSubscriptionPaymentMethod = () => {
  const remoteConfig = firebase.remoteConfig();

  remoteConfig.settings.minimumFetchIntervalMillis = 0;

  return remoteConfig
    .fetchAndActivate()
    .then(() => {
      return remoteConfig.getValue("SUBSCRIPTION_PAYMENT_METHOD");
    })
    .catch((err) => {
      throw err
    });
};

export {
  getTCAndPPFromRemoteConfig,
  getUrlsLocationFromRemoteConfig,
  getSeasonRegistrationUrl,
  getSubscriptionPaymentMethod,
  getPromotionPopupConfig,
};



// WEBPACK FOOTER //
// ./src/js/utils/firebase/remoteConfig.js